// Escavador API - chamadas diretas do browser
// Configure o token em .env: REACT_APP_ESCAVADOR_TOKEN=seu_token
export const ESCAVADOR_API_URL = 'https://api.escavador.com/api/v2';

export const escavadorHeaders = () => ({
  'Authorization': `Bearer ${process.env.REACT_APP_ESCAVADOR_TOKEN}`,
  'Content-Type': 'application/json',
});
